@if (showIcon()) {
    <div class="cs-mobile-i-icon theme-info" data-decoratorclass-host data-legacy="true"></div>
}
